export enum FieldSetupEnum {
  SETS_REPETITIONS = 'SETS_REPETITIONS',
  INTERVAL = 'INTERVAL',
  WEIGHT = 'WEIGHT',
  CADENCE = 'CADENCE',
  NOTE = 'NOTE',
  SETS = 'SETS',
  STIMULUS_TIME_DISTANCE = 'STIMULUS_TIME_DISTANCE',
  SPEED = 'SPEED',
  PACE = 'PACE',
  REST = 'REST'
}
